import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_PermissionToTransport = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_PermissionToTransport' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Permission to Transport</h3></p>

                <p className='w-750'>
                    I give my permission to be transported in a motor vehicle driven by their
                    community based worker at Lilly Pad Home Health for any requested occasion,
                    such as doctor's appointments, any clinical appointment, or any community event, such as
                    community service or community gathering, or whenever the community based worker and I feel
                    transportation to be in the best interest of my child. I understand that my child is expected
                    to follow all applicable laws regarding riding in a motor vehicle and is expected to follow the directions
                    provided by the driver and/or other adult passengers Lilly Pad Home Health hold responsible to verify all community
                    based workers have current motor vehicle insurance and Lilly Pad Home Health itself, will maintain commercial liability insurance as well.
                </p>

                <p className='w-750'><hr /></p>

                <p className='w-750'>
                    Further, I recognize that participating with any activity involving motor
                    vehichle transportation, my child may risk personal injury or permanent loss.
                    I hereby attest and verify that I have been advised of the potential risks, that I have full
                    knowledge of the risks involved in the activity and that I assume any expenses that may be incurred
                    in the event of an accident, illness, or other capacity, regardless of whether I have authorized such expenses.
                </p>

                <p className='w-750'><hr /></p>

                <p className='w-750'>
                    In addition, I hold harmless and release Lilly Pad Home Health and its partners
                    and entities from any liability as a result of ungovernable behavior of my child during
                    transportation or during the event or occasion for which transportation was needed or deemed necessary. As
                    a condition for transportation received, I, for myself, my child, my executors and assigns, further agree to
                    release and forever discharge The Creed Group, its partners, entities, agents, officers, employees and volunteers
                    from any claim that I might have myself or that I could bring on my child's behalf with regards to any damages, demands, or
                    actions whatsoever, including those based on negligence, in any manner arising out of this transportation. In Summary by signing below:
                </p>

                <p className='w-750'><hr /></p>

                <p className='w-750'>
                    <ol type='I'>
                        <li>
                            I will not hold Lilly Pad Home Health, its officers, agents, employees, assigns or
                            anyone acting on its behalf, responsible or liable for injury occurring to the named perswon in the course
                            of such activities or such travel.
                        </li>
                        <li>
                            I hereby accept financial responsibility for personal items lost by the person identified herein.
                        </li>
                        <li>
                            I authorize Lilly Pad Home Health to transport and to obtain, through a physician of
                            its own choice, any emergency medical care that may become reasonably necessary for the person in the course
                            of such activities/events or such travel, and agree to accept the cost of the transportation and/or treatment
                            by medical personnel or facility.
                        </li>
                        <li>
                            I accept full responsibility and hereby grant permission for me or my minor child to travel with Lilly Pad Home Health.
                        </li>
                    </ol>
                </p>
                <p className='w-750'>
                    I have read this entire waiver and permission form, fully understand it, and agree to be legally bound by its terms.
                </p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Client Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent/Guardian Name</span>
                            <span className='small'> (please print):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' name='txtClientName' id='txtClientName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' name='txtParentGuardianName' id='txtParentGuardianName' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-750'></td>
                    </tr>
                    <tr>
                        <td className='small w-750'>Parent/Guardian Signature:</td>
                    </tr>
                    <tr>
                        <td className='signature w-750'></td>
                    </tr>
                    <tr>
                        <td className='small w-750'>Date:</td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











